import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/idnp-automations/playbooks/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.ShowAutomations];
    context.validatePermissions({ isAllowed, preload });
  },
});
